@if (post) {
    <mat-dialog-content>
        <div class="flex-row flex-space-between w-100 pt-10">
            <div class="flex-row gap-15 pl-10">
                @if (post?.author && post?.author.id > 0) {
                    <div>
                        <div [matMenuTriggerFor]="menu" class="moderator clickable"
                             (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false">
                            <app-online-status-badge [isStaff]="post.author?.is_staff"
                                                     [userId]="post.author.id"></app-online-status-badge>
                        </div>
                        <div [appUserAvatar]="post.author" [matMenuTriggerFor]="menu" class="miniInitial clickable"
                             [class.onlineIndicatorOffset]="!community?.disable_online_icon_next_to_profile_picture || post.author?.is_staff"
                             (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false"
                             mat-card-avatar>
                            {{ post.author.username | slice: 0 : 1 | titlecase }}
                        </div>
                        <mat-menu #menu="matMenu" class="userDisplayMenu">
                            @if (userInfoMenuOpen) {
                                <app-user-info [user]="post.author"></app-user-info>
                            }
                        </mat-menu>
                    </div>
                } @else {
                    <div class="miniInitial" mat-card-avatar matTooltip="This post was posted anonymously">A
                    </div>
                }
                <div class="flex-col">
                    <mat-card-title>{{ post.title }}</mat-card-title>
                    <mat-card-subtitle>{{ post.created_at | relativeTime }}</mat-card-subtitle>
                </div>
            </div>
            <div class="w-100 d-flex justify-content-end p-fixed closBtnHolder">
                <div class="closeBtn">
                    <button class="mat-dialog-close" (click)="exitCheck()" mat-mini-fab matTooltip="Close post"
                            aria-label="Close comments">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <mat-card-content>
            <app-post-content [content]="post" [disableOverlay]="true"></app-post-content>
            @if (poll && poll.id) {
                <app-poll-view
                        [forceShowResults]="hasCommunityRole(['client', 'reports_only', 'full_admin', 'observer'])"
                        [pollId]="poll.id"></app-poll-view>
            }
        </mat-card-content>
        @if (!this.selectedCommunity?.comment_box_at_bottom) {
            <ng-container [ngTemplateOutlet]="commentInput"
            ></ng-container>
        }
        <div class="flex-row gap-5 align-items-center">
            Sort comments:
            <button [matMenuTriggerFor]="commentsSort" mat-button>
                <mat-icon>{{ selectedSortOption.icon }}</mat-icon>
                {{ selectedSortOption.label }}
            </button>
        </div>
        <app-comments-list class="fixMentionOverflow" [comments]="commentsTree" [post]="post"></app-comments-list>
        @if (this.selectedCommunity?.comment_box_at_bottom) {
            <ng-container [ngTemplateOutlet]="commentInput"
            ></ng-container>
        }
    </mat-dialog-content>
}

<mat-menu #commentsSort="matMenu">
    @for (sortOption of sortOptions; track sortOption) {
        <button (click)="sortComments(sortOption)" mat-menu-item>
            {{ sortOption.label }}
        </button>
    }
</mat-menu>

<ng-template #commentInput>
    @if (!post.comments_off && (isSuperuser || hasCommunityRole(['member', 'client', 'full_admin']))) {
        <app-reply-field (action)="updateComment($event)" [prefillComment]="prefillComment"
                         [post]="post"></app-reply-field>
    }
</ng-template>
